import SC from "./style";
import { useState, useEffect } from "react";
import { apiPost } from "api/callApi";
import { Button, Loader } from "InnoUI/components";
import theme from "theme";
import { TextInput } from "InnoUI/innoinput";
import InnoIcons from "InnoUI/innoicons";
import { InputField } from "components";
import { showAlert } from "utils/helper";

const AddEditRole = (props) => {
  const { onClose, isEditing, roledata, rowId, fetchData, rowData } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    role: "",
    description: "",
  });

  useEffect(() => {
    if (isEditing && roledata) {
      const updatedData = { ...roledata };
      updatedData.adminStatus = updatedData.userType !== 2;
      setData(updatedData);
    }
  }, [isEditing, roledata]);

  const handleChange = (name, value) => {
    // Regex to check if the input contains only numbers
    const onlyNumbersRegex = /^\d+$/;

    // If the input contains only numbers, reject it
    if (onlyNumbersRegex.test(value)) {
      console.log("Invalid input: Only numbers are not allowed.");
      return;
    }

    // Trim the value and update the state
    const trimmedValue = value;
    setData({ ...data, [name]: trimmedValue || null });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const endpoint = isEditing ? `/v1/role/${rowId}` : `/v1/role`;
    try {
      const response = await apiPost(endpoint, data);
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      await fetchData();
      onClose();
    } catch (error) {
      showAlert({
        title: "Error",
        text: error.response?.data?.message || "An error occurred",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle keydown event to prevent form submission on Enter key
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission on Enter key press
    }
  };
  return (
    <>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>
          {isEditing ? "Edit Role" : "New Role"}
        </SC.DrawerTitles>
        <SC.CloseIcon>
          <InnoIcons.CloseIcon onClick={onClose} />
        </SC.CloseIcon>
      </SC.DrawerTitlesContainer>

      {loading && <Loader />}

      {/* Add onKeyDown to the form */}
      <SC.Form onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
        <SC.FormWrapper>
          <SC.LabelContainer>
            <SC.Label>Role</SC.Label>
            <InputField
              name="role"
              defaultValue={data.role}
              value={data.role}
              onChange={handleChange}
              style={{
                width: "380px",
                resize: "none",
              }}
              required
              // capitalize={true}
              disabled={rowData?.systemRole == 1}
            />
          </SC.LabelContainer>

          <SC.LabelContainer>
            <SC.Label>Description</SC.Label>
            <SC.Children>
              <TextInput
                name="description"
                defaultValue={data.description}
                value={data.description}
                onChange={(value, name) => handleChange(name, value)}
                isTextArea
                size="large"
                style={{
                  width: "380px",
                  height: "80px",
                  fontSize: "12px",
                  border: `1px solid ${theme.colors.bordertask}`,
                  borderRadius: "3px",
                  resize: "none",
                }}
              />
            </SC.Children>
          </SC.LabelContainer>

          {/* Buttons */}
          <SC.ButtonContainer>
            <Button
              caption="Cancel"
              onClick={onClose}
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: "#EFEFEF",
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
              }}
            />
            <Button
              caption={isEditing ? "Save" : "Add"}
              type="submit"
              isLoading={loading}
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
            />
          </SC.ButtonContainer>
        </SC.FormWrapper>
      </SC.Form>
    </>
  );
};

export default AddEditRole;
